import React, { useEffect, useState } from 'react';
import { numberWithCommas, numberWithNoCommas } from '../../../utils/common';
function InputMoney(props) {
  const { register, title, setError, errors, placeholder, zeroAllow, defaultValue, disabled, setValue, required = true, maxDigits } = props;
  const [valueInside, setValueInside] = useState(defaultValue ? numberWithCommas(defaultValue) : '');

  useEffect(() => {
    if (defaultValue) {
      setValueInside(numberWithCommas(defaultValue));
      if(setValue){
        setValue(title, numberWithCommas(defaultValue));
      }
    }else{
      setValueInside('');
      if(setValue){
        setValue(title, '');
      }
    }
  }, [defaultValue]);

  const onChangeValue = (input) => {
    const limitedInput = maxDigits ? numberWithNoCommas(input).slice(0, maxDigits) : input;
    let nextValue = numberWithCommas(limitedInput);

    if ((limitedInput || '').startsWith('0') && !zeroAllow) {
      nextValue = numberWithCommas('');
      setValueInside(nextValue);
      if (setValue) {
        setValue(title, nextValue);
      }
      return;
    }
    if (placeholder !== '' && Number(numberWithNoCommas(limitedInput)) > 400000) {
      nextValue = numberWithCommas(400000);
    } else {
      nextValue = numberWithCommas(limitedInput);
    }

    setValueInside(nextValue);
    if (setValue) {
      setValue(title, nextValue);
    }
    setError(title, null);
  };
  return (
    <>
      <div className="flex border-b border-primary">
        <p className="text-xl text-primary mr-2">HK$</p>
        <input
          disabled={disabled}
          inputMode={'numeric'}
          {...register(title, { required, pattern: /^[0-9,]*$/ })}
          onChange={(e) => onChangeValue(e.target.value)}
          value={valueInside}
          className="flex-1 px-2 outline-none text-primary"
          placeholder={placeholder ?? '(最高$400,000)'}
          {...(placeholder !== '' && { maxLength: 7 })}
        />
      </div>
      {errors?.[title] && errors?.[title]?.type === 'required' && <span className="text-10 text-red-500">*必填</span>}
      {errors?.[title] && errors?.[title]?.type === 'pattern' && <span className="text-10 text-red-500">*无效的</span>}
    </>
  );
}

export default InputMoney;
